import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import { faqs } from "@/mocks/hotNews";
import HomeHero from "./components/HomeHero";
import HomeCategories from "./components/HomeCategories";
import HomeRanking from "./components/HomeRanking";
import HomeFeed from "./components/HomeFeed";
import HomeGuide from "./components/HomeGuide";
import HomeFaq from "./components/HomeFaq";
import HomeVoices from "./components/HomeVoices";

const orgLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "在线吃瓜",
  description: "追踪全网热门话题与新鲜事的实时资讯平台，提供今日热瓜实时榜单。",
  url: "https://www.zgchigua.cn/",
};
const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "在线吃瓜",
  url: "https://www.zgchigua.cn/",
  inLanguage: "zh-CN",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.zgchigua.cn/news?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};
const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  return (
    <Layout>
      <Seo
        title="在线吃瓜 - 今日热瓜实时榜单_热门话题新鲜事"
        description="在线吃瓜追踪全网最新进展，不错过任何一条劲爆消息。今日热瓜实时榜单、热门话题新鲜事即时更新，快速锁定此刻全网都在关注的焦点动态。"
        keywords="在线吃瓜,今日热瓜,实时榜单,热门话题,新鲜事,最新进展,即时更新"
        path="/"
        jsonLd={[orgLd, websiteLd, faqLd]}
      />
      <HomeHero />
      <HomeCategories />
      <HomeRanking />
      <HomeFeed />
      <HomeGuide />
      <HomeFaq />
      <HomeVoices />
    </Layout>
  );
}